import React, { memo, useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

import { Creators as LoadersActions } from "../../store/ducks/loaders";
import { Creators as NotificationsActions } from "../../store/ducks/notifications";

import { mergeObject } from "../../utils/Object";

import ReportService from "../../services/Report";
import ReportSchema from "../../services/Report/Schema";

const Cancel = ({
  options,
  props: {
    currentUser
  },
  funcs: {
    addNotice,
    disableLoader,
    enableLoader
  }
}) => {
  const { t } = useTranslation();
  const reportService = new ReportService();

  const {
    close: __close = () => {},
    report: __report = {}
  } = options;

  const [report] = useState(mergeObject(JSON.parse(JSON.stringify(ReportSchema)), __report));
  const [running, setRunning] = useState(false);

  useEffect(() => {
    cancelReport();
  }, []); /* eslint-disable-line */

  const cancelReport = async () => {
    if(!running) {
      setRunning(true);
      enableLoader();
      const response = await reportService.reportCancel({ id: report.id, token: currentUser.token });
      if(response.success) {
        addNotice({
          title: t("Title.MyReports.Cancel"),
          content: t("Success.Report.Cancel.Request")
        });
      }
      else {
        addNotice({
          title: t("Title.MyReports.Cancel"),
          content: t("Error.Report.Cancel.Request")
        });
      }
      setTimeout(() => {
        disableLoader();
        setRunning(false);
        __close();
      }, 100);
    }
  };

  return (
    <div className="user-reports-cancel-content-data" />
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, LoadersActions, NotificationsActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(Cancel));
